// const initAuthenticationModal = () => {
//   const forms = modal.querySelectorAll('form');
//   forms.forEach(form => {
//     form.addEventListener('submit', async (e) => {
//
//     });
//   });
// };

class RegistrationModal extends HTMLElement {
	constructor() {
		super()
		this.modal = this
		this.tabButtons = this.modal.querySelectorAll(".tab-button")
		this.tabContents = this.modal.querySelectorAll(".tab-content")
		this.registerForm = this.modal.querySelector("#create_customer")
		this.phoneNumberInput = this.modal.querySelector("#modalPhoneNumber")
		this.businessNameInput = this.modal.querySelector("#modalBusinessName")
		this.notesInput = this.modal.querySelector("#modalNotes")
	}

	updateNotes() {
		this.notesInput.value = `business_name:${this.businessNameInput.value},phone_number:${this
			.phoneNumberInput.value}`
	}

	initRegisterForm() {
		this.phoneNumberInput.addEventListener("input", () => this.updateNotes())
		this.businessNameInput.addEventListener("input", () => this.updateNotes())
	}

	hideAuthenticationModal() {
		this.modal.classList.remove("is-active")
		document.documentElement.style.overflow = "auto"
	}

	initAuthenticationModal() {
		this.tabButtons.forEach(button => {
			button.addEventListener("click", () => {
				this.switchTab(button.dataset.tab)
			})
		})
		this.initRegisterForm()
	}

	switchTab(targetTab) {
		this.tabButtons.forEach(btn => {
			const isSelected = btn.dataset.tab === targetTab
			btn.classList.toggle("active", isSelected)
			btn.setAttribute("aria-selected", isSelected)
		})

		this.tabContents.forEach(content => {
			const isActive = content.id === `${targetTab}-tab`
			content.classList.toggle("active", isActive)
		})
	}

	connectedCallback() {
		this.initAuthenticationModal()
	}
}
customElements.define("registration-modal", RegistrationModal)
